import { type FC, useEffect } from 'react';

import { Moon, Sun } from 'lucide-react';
import { observer } from 'mobx-react-lite';

import { useHydrated } from '@shared/lib';

import styles from './ThemeSwitcher.module.css';
import { themeStore } from '../model/store';

export const ThemeSwitcher: FC = observer(() => {
  const hydrated = useHydrated();
  const isDark = hydrated ? themeStore.isDark : true;
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const sync = () => themeStore.syncSystemTheme();
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  }, []);

  return (
    <button
      className={styles.trigger}
      type="button"
      onClick={themeStore.toggle}
      aria-label={isDark ? 'Переключить на светлую тему' : 'Переключить на тёмную тему'}
      title={isDark ? 'Светлая тема' : 'Тёмная тема'}
    >
      {/* CSS выбирает правильную иконку ещё до гидратации. */}
      <Sun aria-hidden data-show-in-theme="dark" />
      <Moon aria-hidden data-show-in-theme="light" />
    </button>
  );
});
